import { render, staticRenderFns } from "./FreightPopup.vue?vue&type=template&id=e9514512&scoped=true&"
import script from "./FreightPopup.vue?vue&type=script&lang=js&"
export * from "./FreightPopup.vue?vue&type=script&lang=js&"
import style0 from "./FreightPopup.vue?vue&type=style&index=0&id=e9514512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9514512",
  null
  
)

export default component.exports